import { useEffect, useState } from 'react'
import { fetchAdminPublicInfo } from '../pages/Dashboard/Api/Admin/Admin'
import { AdminPublicInfo } from '../pages/Dashboard/Api/Admin/models'

export const useAdminInfo = () => {
    const [adminInfo, setAdminInfo] = useState<AdminPublicInfo | null>(null);
    const getAdminInfo = async () => {
        const info = await fetchAdminPublicInfo()
        if (info) {
            setAdminInfo(info)
        }
    }

    useEffect(() => {
        if (!adminInfo) {
            getAdminInfo()
        }
    }, [adminInfo])

    return { adminInfo, getAdminInfo }
}
